
import React from 'react'
import { PuffLoader } from 'react-spinners'

const Loader = ({height}) => {
  return (
    <div style={{width:"100%", height:height || "100svh", display:"flex",alignItems:"center",justifyContent:"center"}}>
        <PuffLoader
              color="green" 
              loading= {true}
              size={150}
              aria-label="Loading Spinner" 
              data-testid="loader" 
            />
    </div>
  )
}

export default Loader